import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { Opportunity } from '@interfaces';
import { AppService } from '../../../../../../services';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, app: AppService): GridSetup<Opportunity> {

	return {
		rowName: { singular: 'Opportunity', plural: 'Opportunities' },
		getRowKey: row => '' + row.opportunityId,
		stateKey: 'devo-pipeline-opportunities-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util, app),
	}
}
